import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { FirstLoginService } from './first-login.service';

/**
 * Guard for the /first-login route.
 * Allows access only if the user needs to complete FTL.
 * If FTL is complete, redirects to /home.
 */
export const firstLoginGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getUser();

  if (!user) {
    return router.parseUrl('/login');
  }

  if (FirstLoginService.shouldShowFirstTimeLogin(user)) {
    return true;
  }

  return router.parseUrl('/home');
};

/**
 * Guard that redirects authenticated users to /first-login if they
 * still need to complete FTL. Used on /home, /encounters, /settings, etc.
 */
export const firstLoginRedirectGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const ftlService = inject(FirstLoginService);
  const router = inject(Router);
  const user = authService.getUser();

  if (!user) {
    return true; // Let authGuard handle unauthenticated
  }

  if (ftlService.hasNavigatedToFirstLogin) {
    return true;
  }

  if (FirstLoginService.shouldShowFirstTimeLogin(user)) {
    return router.parseUrl('/first-login');
  }

  return true;
};
